import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { cnst } from '../../../model/cnst';
import { Params, Router, RouteReuseStrategy } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MasterService, FileItem  } from 'src/app/services/master.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { MatTableDataSource } from '@angular/material/table';
import { VEntities, Entities, SecurityLevel, VModule, Calculation } from '../../../model/structures';
import { faCoffee, faShieldHalved, faPen, faEnvelope, faPhone, faShield, faBoxArchive } from '@fortawesome/free-solid-svg-icons';
import { FormlyJsonschema } from '@ngx-formly/core/json-schema';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { throwDialogContentAlreadyAttachedError } from '@angular/cdk/dialog';
import { MatStepper } from '@angular/material/stepper';
import { switchMap } from 'rxjs/operators';



@Component({
  selector: 'app-create-calc-master',
  templateUrl: './create-calc-master.component.html',
  styleUrls: ['./create-calc-master.component.css']
})
export class CreateCalcMasterComponent implements OnInit {
  @ViewChild('stepper') stepper!: MatStepper;
  public parent_id!: number;
  //---
  public faShieldHalved = faShieldHalved;
  public faPen = faPen;
  public faEnvelope = faEnvelope;
  public faPhone = faPhone;
  public faShield = faShield;
  public faBoxArchive = faBoxArchive;

  //public parent_id: any;
  public Entity = <Calculation>{};
  public module_list: VModule[] = [];
  public security_data!: SecurityLevel[];
  public security_level_selected: any;

  DataSourceTable: any;
  //displayedColumns: string[] = ['ID', 'ShortTitle', 'Description', 'ArchiveSign', 'SecurityLevel'];
  displayedColumns: string[] = ['ID', 'ShortTitle', 'SecurityLevel'];
  selected_module!: VModule;
  //-----------Stepper--------------
  firstFormGroup = this._formBuilder.group({
    selected_module: ['', Validators.required],
    ///firstCtrl: [''],
  });
  calc_form: FormGroup;
  isEditable = true;
  //
  records: any[] = [];
  headers: any[] = [];
  public filesList: any[] = [];
  public selectedFile: any; 
  //-----------Formly--------------
  form = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};

  fields: FormlyFieldConfig[] = [];
  template: any;
  public private_content: any = {};
  public open_content: any = {};
  submit() {
    if (this.form.valid) {
      console.log(JSON.stringify(this.model));
    }
  }
  //----------------------------------
  tmp: any;
  header: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public service: MasterService,
    public storageService: AuthenticationService,
    private _formBuilder: FormBuilder,
    private http: HttpClient,
    private _snackBar: MatSnackBar
  ) {
    this.calc_form = this._formBuilder.group(
      {
        ID: new FormControl(''),
        ShortTitle: new FormControl('', Validators.required),
        Description: new FormControl(''),
        Module: new FormControl(''),
        InOutFile: new FormControl(''),
        Status: new FormControl(''),
        Path: new FormControl('')
      }
    );
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.parent_id = params['parent_id'];
      this.GetTemplateList();
      this.InitForm();
    });
  }
  //--------------------------------------------------------
  //----------------------------------
  public GetTemplateList() {
    this.service.RedKeyGetModulesList().subscribe((result: any) => {
      if (result.data != null) {
        this.storageService.saveToken(result.jwt);

        this.module_list = [];
        this.module_list = result.data.filter((m: any) => m.ArchiveSign === false);

        this.DataSourceTable = new MatTableDataSource<VModule>(this.module_list);
        this.DataSourceTable.filterPredicate = (data: VModule, filter: string) => {
          const searchable = (data.ID + ' ' + data.ShortTitle).toLowerCase();
          return searchable.indexOf(filter) !== -1;
        };
      }
      else {
        console.log('error');
        //this.router.navigate(['login']);
      }
    });
  }
  //--------------------------------------------------------
  InitForm() {

  }
  //------------------------------------------------------------------------------
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.DataSourceTable.filter = filterValue.trim().toLowerCase();
  }
  //------------------------------------------------------------------------------
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || !input.files.length) return;
    this.newFile = input.files[0];
  }

  openSpecialCalc() {
    const pid = this.parent_id;
    const url = `${window.location.origin}/#/home/special_calc;parent_id=${pid};module_id=5`;
    window.open(url, '_blank');
  }
  public newFile: File | null = null;
  public uploading = false;


  getrow(row: VModule) {
    this.selected_module = row;
    this.firstFormGroup.setValue({ selected_module: row.ShortTitle });
    this.filesList = [];  // очищаем старый список

    this.service.getFilesByModule(row.ID).subscribe({
      next: (resp: { data: FileItem[]; jwt: string }) => {
        this.filesList = resp.data;
      },
      error: (err: any) => {
        console.error('Error loading files:', err);
        this._snackBar.open('Не удалось загрузить файлы', '', {
          panelClass: ['red-snackbar'],
          duration: 2000,
        });
      },
    });
  }


    selectFile(file: any) {
    this.selectedFile = file;
    this._snackBar.open(`Выбран файл: ${file.ShortTitle}`, '', {
      duration: 2000,
    });
  }


  // getrow(row: VModule) {
  //   console.log('getrow called, row.ID=', row.ID);
  //   this.selected_module = row;
  //   this.firstFormGroup.setValue({ selected_module: row.ShortTitle });
    
  //   // Загружаем файлы для выбранного модуля
  //   this.getFilesForModule(row.ID);
  // }
  previewFile(file: any) {
    console.log('Previewing file:', file);

  }
  //--------------------------------------------------------
  onSubmit() {

  }
  //--------------------------------------------------------
  exit() {
    this.router.navigate(['home/calculation_list', { id: this.parent_id }]);
  }
  //------------------------------------------------------------------------------
  changeListener(_event: any) {
    console.log(_event);
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.calc_form.controls['InOutFile'].setValue(event.target.result);
      //
      let csvToRowArray = event.target.result.split("\n");
      this.headers = csvToRowArray[0].split(",").map((e: any) => e.trim());
      this.records = csvToRowArray.slice(1).map((row: any) => row.split(","));
      //
    };
    reader.onerror = (event: any) => {
      console.log("File could not be read: " + event.target.error.code);
    };
    reader.readAsText(_event.files[0]);
  }
  //----------------------------------
  save(): void {
    if (!this.selected_module) {
      this._snackBar.open('Сначала выберите модуль', '', { duration: 2000 });
      return;
    }
    if (!this.newFile) {
      this._snackBar.open('Выберите файл для загрузки', '', { duration: 2000 });
      return;
    }

    this.uploading = true;
    this.service.uploadModuleFile(this.selected_module.ID, this.newFile)
      .pipe(
        switchMap(uploadRes => {
          this.Entity.ShortTitle  = this.calc_form.value.ShortTitle;
          this.Entity.Description = this.calc_form.value.Description;
          this.Entity.Project     = this.parent_id;
          this.Entity.Module      = this.selected_module.ID;
          this.Entity.InOutFile   = uploadRes.url;
          this.Entity.Status      = 'Черновик';
          this.Entity.Path        = '';
  
          return this.service.RedKeyCreateCalculation(this.Entity);
        })
      )
      .subscribe({
        next: result => {
          this.uploading = false;
          if (result.res === 'success') {
            this._snackBar.open('Файл загружен и расчёт создан', '', { duration: 2000 });
            this.router.navigate(['home/calculation_list', { id: this.parent_id }]);
            this.service.getFilesByModule(this.selected_module.ID).subscribe({
              next: resp => {
                this.filesList = resp.data;
                this.storageService.saveToken(resp.jwt);
              },
              error: () => {
              }
            });

          } else {
            this._snackBar.open('Ошибка сервера при создании расчёта', '', {
              panelClass: ['red-snackbar'],
              duration: 2000
            });
          }
        },
        error: err => {
          this.uploading = false;
          console.error(err);
          this._snackBar.open('Ошибка при загрузке файла', '', {
            panelClass: ['red-snackbar'],
            duration: 2000
          });
        }
      });
  }



  //-----------------------------------------------------------------
}